import styled from 'styled-components'

export default styled.div`
  color: ${({ theme }) => theme.colors.error};
  font-size: 14px;
  font-weight: bold;
`
